import styles from '@/../sass/components/OrganizationLogoManagement.module.scss';
import {Link, usePage} from "@inertiajs/inertia-react";
import {FileUploadArea} from "@/Components/FileUploadArea";
import i18n from "i18next";
import React, {useState, useEffect} from "react";

export function OrganizationLogoManagement({
                                               logoUrl,
                                               onFileUploaded = () => {
                                               },
                                               organizationName = 'Your Organization',
                                               deleteLogo = true,
                                               onDelete = () => {
                                               }, dataTestid
                                           }) {
    const [state, setState] = useState({logoUrl: logoUrl})

    const { flash, assetDomain } = usePage().props;

    function onUploaded(data) {
        setState({...state, logoUrl: `${assetDomain}/${data.key}`})
        onFileUploaded(data)
    }

    function resetState() {
        setState({...state, logoUrl: null});
    }

    useEffect(() => {
        if (flash && flash.type === 'warning' && flash.message === i18n.t("organization-account.logo-error")) {
            setState(state => ({ ...state, logoUrl: null, flashMessage: flash.message }));
        }
    }, [flash]);

    return (
        <div data-testid={'organization_logo_management-div-'+dataTestid} className={styles.wrap}>
            {state.logoUrl &&
                <div className={styles.logoWrap}>
                    <div data-testid="organization_logo_management-div-img_div" className={styles.logo}><img src={state.logoUrl} alt={`${organizationName} logo`} title={`${organizationName} logo`}/>
                    </div>
                    {deleteLogo && (<Link
                        data-testid="organization_logo_delete-button"
                        as="button"
                        method="DELETE"
                        href={route('manage.organization.logo.destroy')}
                        className={`btn btn-link ${styles.delete}`}
                        onSuccess={resetState}
                    >
                        <span><i className="fas fa-trash"></i></span>
                    </Link>)}
                    {!deleteLogo && (<button data-testid="organization_logo_management-button-delete" className={`btn btn-link ${styles.delete}`} onClick={(e) => {
                            e.preventDefault();
                            setState({...state, logoUrl: false});
                            onDelete(e);
                        }}>
                            <span><i className="fas fa-trash"></i></span>
                        </button>
                    )}
                </div>
            }
            <FileUploadArea
                onUploaded={onUploaded}
                showUploader={true}
                dropText={i18n.t("organization-account.drag-or-drop")}
                browseText={i18n.t("organization-account.choose-file")}
                instructions={i18n.t("organization-account.logo-info")}
                flashMessage={flash?.message}
            />
        </div>
    )
}
